export const ADD_FEEDBACK_QUERY = `
mutation ($input: FeedbackInput) {
	addFeedback(input: $input) {
		id
	}
}`;
